import { useEffect, useState } from "react";
import { getPlayersStats, getPlayersStatsByLegacyIds } from "../../../api/transport/statsTransport";
import { TeamContext } from "../../../types/common";
import { Loader } from "../../../components/Loader";
import { PlayersStatsMiniTable } from "../../../components/player/PlayersStatsTable/PlayersStatsMini";
import { PlayersStatsTableItem } from "../../../types/player";
import { getPlayerInfos } from "../../../api/transport/playersTransport";
import { Empty } from "antd";
import { getUrlByContext } from "../../../utils";
import { MiniTable } from "../../../components/MiniTable";

interface PlayersStatsMiniProps {
    teamId?: number;
    totalPlayers?: number;
    teamContext?: TeamContext;
    tournamentUuid?: string;
    seasonUuid?: string;
    tournamentId?: number;
    seasonId?: number;
}

export const PlayersStatsMiniWidget: React.FC<PlayersStatsMiniProps> = ({
    teamId,
    teamContext,
    totalPlayers,
    tournamentUuid,
    seasonUuid,
    tournamentId,
    seasonId,
}) => {
    const [playersStats, setPlayersStats] = useState<PlayersStatsTableItem[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        //getPlayersStats(tournamentUuid, seasonUuid, teamId, teamContext).then(async (data) => {
        getPlayersStatsByLegacyIds(tournamentId, seasonId, teamId, teamContext).then(async (data) => {
            const players = await getPlayerInfos(data.map((playerStats) => playerStats.id), teamContext);
            const stats: PlayersStatsTableItem[] = [];
            data.forEach((playerStats) => {
                const player = players.find((p) => p.stats.id === playerStats.id);
                if (!player) {
                    return;
                }
                stats.push({
                    ...playerStats,
                    name: player?.name,
                    photo: player?.photo,
                    url: player?.url,
                });
            });
            setPlayersStats(stats.slice(0, totalPlayers));
        }).catch((error) => {
            setPlayersStats([]);
        }).finally(() => {
            setLoading(false);
        });
    }, [teamId, teamContext, tournamentUuid, seasonUuid]);

    if (loading) {
        return <Loader />;
    }

    if (!playersStats.length) {
        return <Empty description={false} />;
    }

    const searchParams = new URLSearchParams();
    searchParams.set('turnir', tournamentId.toString());
    searchParams.set('sezon', seasonId.toString());

    return (
        <MiniTable
            title="Бомбардиры"
            link={{
                title: "Все",
                url: getUrlByContext(`/games/stat/?${searchParams.toString()}`, teamContext),
            }}
        >
            <PlayersStatsMiniTable
                data={playersStats}
            />
        </MiniTable>
    )
}

